module.exports = __webpack_public_path__ + "media/images/illustrations/flat_clip_success-6fd94c41ff24a3335bcb748e1f5e45b1.png";